import type { Store } from '../store/types';
import { FETCH_SUGGESTIONS, SUGGESTIONS_RESET_SERVICES } from '../actions';
import type { Suggestions } from '../types/suggestions';
import { getSuggestions } from '../api';
import { createCookies, getLangFromCookies, getRegion, getDomain, DEFAULT_KZ_REGION } from '../utils';

export const suggestions = (store: Store) => {
  store.on('@init', () => ({
    suggestions: { suggestions: null, error: false, loading: false },
  }));

  store.on(FETCH_SUGGESTIONS.init, (_, props) => {
    const {
      apiKey,
      cookies,
      host: hostname,
      orchestratorHost,
      orchestratorHostKz,
      requestID,
      useCredentials,
    } = store.get();
    const lang = getLangFromCookies(createCookies(cookies));
    const domain = getDomain(hostname);
    const region = getRegion(hostname, domain);
    const isKzHost = !__IS_SERVER__ && orchestratorHostKz && region === DEFAULT_KZ_REGION;
    const host = isKzHost ? orchestratorHostKz : orchestratorHost;

    store.dispatch(FETCH_SUGGESTIONS.request, true);

    return getSuggestions({ ...props, lang }, { orchestratorHost: host, useCredentials, apiKey, requestID })
      .then((data) =>
        store.dispatch(FETCH_SUGGESTIONS.success, {
          query: props.query ?? '',
          categories: data.categories ? [...data.categories] : [],
          redirects: data.redirects ? [...data.redirects] : [],
          newSuggestions: data.newSuggestions ? [...data.newSuggestions] : [],
          completions: data.completions ? [...data.completions] : [],
        }),
      )
      .catch(() => store.dispatch(FETCH_SUGGESTIONS.failure, true));
  });

  store.on(FETCH_SUGGESTIONS.request, (state) => ({
    suggestions: {
      ...state.suggestions,
      loading: true,
      error: false,
    },
  }));

  store.on(FETCH_SUGGESTIONS.success, (_state, data: Suggestions) => {
    const { categories, redirects, newSuggestions, completions, query } = data;

    return {
      suggestions: {
        suggestions: {
          categories: categories || [],
          redirects: redirects || [],
          newSuggestions: newSuggestions || [],
          completions: completions || [],
          query: query ?? '',
        },
        loading: false,
        error: false,
      },
    };
  });

  store.on(FETCH_SUGGESTIONS.failure, () => ({
    suggestions: { suggestions: null, loading: false, error: true },
  }));

  store.on(SUGGESTIONS_RESET_SERVICES, (state) => {
    if (state.suggestions.suggestions != null)
      return {
        suggestions: {
          suggestions: {
            categories: [],
            redirects: [],
            newSuggestions: [],
            query: '',
          },
          loading: state.suggestions.loading,
          error: state.suggestions.error,
        },
      };

    return state;
  });
};

export type SuggestionsStore = {
  suggestions: {
    suggestions: Suggestions | null;
    loading: boolean;
    error: boolean;
  };
};
